import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isImpersonating, getImpersonatedCompanyName, stopImpersonation } from '../lib/impersonation';

export default function ImpersonationBanner() {
  const navigate = useNavigate();

  if (!isImpersonating()) return null;

  const handleExit = () => {
    stopImpersonation();
    navigate('/admin/companies');
    window.location.reload();
  };

  return (
    <div
      className="px-4 py-2 text-sm text-center font-medium bg-red-600 text-white flex items-center justify-center gap-3"
      data-testid="impersonation-banner"
    >
      <span>Вы вошли как «{getImpersonatedCompanyName() || 'компания'}» (режим поддержки)</span>
      <button
        type="button"
        onClick={handleExit}
        className="underline font-semibold hover:opacity-80"
        data-testid="exit-impersonation-button"
      >
        Выйти
      </button>
    </div>
  );
}
